import React, { useEffect, useState } from "react";
import {
    Card,
    Form,
    Input,
    Button,
    Select,
    Row,
    Col,
    message,
    Typography,
    Space
} from "antd";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../../configs";

const { Title } = Typography;
const { Option } = Select;

export default function ContactForm() {
    const [form] = Form.useForm();
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            setLoading(true);
            axiosInstance
                .get(`/contact/${id}`)
                .then((res) => {
                    form.setFieldsValue(res.data);
                })
                .catch((err) => {
                    message.error("Gagal mengambil data kontak");
                })
                .finally(() => setLoading(false));
        }
    }, [id, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            if (id) {
                await axiosInstance.put(`/contact/${id}`, values);
                message.success("Kontak berhasil diperbarui");
            } else {
                await axiosInstance.post("/contact", values);
                message.success("Kontak berhasil dibuat");
            }
            history.push("/referensi/kontak");
        } catch (err) {
            console.error(err);
            message.error(err.response?.data?.error || "Gagal menyimpan data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card>
            <div style={{ marginBottom: 24, display: "flex", alignItems: "center" }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => history.push("/referensi/kontak")}
                    style={{ marginRight: 16 }}
                />
                <Title level={4} style={{ margin: 0 }}>
                    {id ? "Edit Kontak" : "Tambah Kontak Baru"}
                </Title>
            </div>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{ contact_type: 1 }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Nama Kontak (Perusahaan / Perorangan)"
                            name="name"
                            rules={[{ required: true, message: "Nama wajib diisi" }]}
                        >
                            <Input placeholder="Nama lengap..." />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Status Grup"
                            name="contact_type"
                            tooltip="Grup mendapat harga khusus, Non-Grup menggunakan harga reguler"
                        >
                            <Select>
                                <Option value={0}>Grup (Harga Khusus)</Option>
                                <Option value={1}>Non-Grup (Harga Reguler)</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Alamat" name="address">
                            <Input.TextArea rows={3} placeholder="Alamat lengkap..." />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Email" name="email">
                            <Input type="email" placeholder="Email..." />
                        </Form.Item>
                        <Form.Item label="Telepon" name="phone">
                            <Input placeholder="Nomor Telepon..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Kode Perusahaan" name="id_kode_perusahaan">
                            <Input placeholder="Kode perusahaan (3 huruf)..." maxLength={10} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="NPWP" name="npwp">
                            <Input placeholder="Nomor NPWP..." />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Contact Person (PIC)" name="cp">
                            <Input placeholder="Nama PIC..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row justify="end">
                    <Space>
                        <Button onClick={() => history.push("/referensi/kontak")}>
                            Batal
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined />}
                            loading={loading}
                        >
                            Simpan
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Card>
    );
}
